import React from 'react';
//@ts-ignore
import {GetCategoryFilters} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';

import TextOverImageThumb from './../text-over-image-thumb/./text-over-image-thumb';

/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  items?: any;
  smallColumns?:string;
  mediumColumns?:string;
  largeColumns?:string;
  height?:string;
  verticalPosition?: string;
  horizontalPosition?: string;
}
interface IState {
  active:boolean;
}
class TextOverImageThumbGrid extends React.Component<IProps>{
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      active:false
    };
  }

  public componentDidMount = async() => {
    setTimeout(() => {
      this.setState({
        active:true
      })
    }, 100);
  }

  public render(): JSX.Element {
    let smallColumns:string = this.props.smallColumns ? this.props.smallColumns: '12';
    let mediumColumns:string = this.props.mediumColumns ? this.props.mediumColumns: '4';
    let largeColumns:string = this.props.largeColumns ? this.props.largeColumns: mediumColumns;
    let height:string = this.props.height ? this.props.height : '25vh';
    let columnClasses:string = 'small-'+smallColumns+' medium-'+mediumColumns+' large-'+largeColumns;
    let activeClass = this.state.active ? 'active' : ' ';
    return (
      <div className={"text-over-image-thumb-grid "+activeClass}>
        {this.props.items && this.props.items.map((item:any,index:any)=>{
          let delayValue = 50 * index;
          return(
            <div className={"text-over-image-thumb-grid-item-wrapper "+columnClasses} style={{height:height, transitionDelay: delayValue+'ms'}}>
               <TextOverImageThumb text={item.text} image={item.image} link={item.link} horizontalPosition={this.props.horizontalPosition} verticalPosition={this.props.verticalPosition} />
            </div>
          )
        })}
      </div>
    );
 }
}

 export default TextOverImageThumbGrid;
